import { useEffect, useRef } from 'react';

const WS_URL = (() => {
  const backend = process.env.REACT_APP_BACKEND_URL || '';
  return backend.replace(/^http/, 'ws') + '/api/ws-native';
})();

export function useProjectRealtime(projectId, onEvent) {
  const wsRef = useRef(null);
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => {
    if (!projectId) return;
    const token = localStorage.getItem('tm_jwt');
    if (!token) return; // Emergent cookie auth: WS needs a token; skip if none
    let closed = false;
    let ws;
    const connect = () => {
      if (closed) return;
      ws = new WebSocket(WS_URL);
      wsRef.current = ws;
      ws.onopen = () => {
        ws.send(JSON.stringify({ type: 'auth', token }));
      };
      ws.onmessage = (ev) => {
        try {
          const data = JSON.parse(ev.data);
          if (data.event === 'auth' && data.ok) {
            ws.send(JSON.stringify({ type: 'join', project_id: projectId }));
          } else if (data.event === 'auth' && !data.ok) {
            localStorage.removeItem('tm_jwt');
            if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/signup')) {
              window.location.href = '/login';
            }
          } else if (data.event) {
            cbRef.current?.(data);
          }
        } catch { /* ignore */ }
      };
      ws.onclose = () => {
        if (!closed) setTimeout(connect, 2000); // reconnect
      };
      ws.onerror = () => { ws.close(); };
    };
    connect();
    return () => { closed = true; try { ws?.close(); } catch { /* noop */ } };
  }, [projectId]);
}
